export interface APIResponse<T = any>{
	error: boolean;
	code?: string | number;
	message?: string;
	data?: T;
}

export interface TokenData{
	access: string;
	expires: number;
}

export interface TeamUser{
	user_id: number;
	email: string;
	first_name: string;
	last_name: string;
	name: string;
	superadmin: boolean;
	notifications: number;
}

export interface UserSession{
	user: TeamUser;
	access: number[];
}

export interface AuthLoginResponse{
	user_id: number;
	first_name: string;
	last_name: string;
	email: string;
	superadmin: boolean;
	access?: number[];
	token: TokenData;
}

export enum LoginSource{
	HR = 1,
}

export enum EmploymentLogType{
	VACATIONS = 1,
	PERMISSION = 2,
	AUTHORIZED_REST = 3,
	DISABILITY = 4,
}

export enum EmploymentScheduleType{
	WORK = 1,
	REST = 2,
}

export interface Schedule{
	schedule_id: number;
	employment_id: number;
	employment_name: string;
	type_id?: number;
	day: number;
	time_start: number;
	time_end: number;
	salary: number;
	log_id?: number;
	log_type_id?: number;
	log_type_name?: string;
	notes?: string;
	date_start?: number;
	date_end?: number;
}

export enum BankAccountOwnerType{
	FISICA = 1,
	MORAL = 2,
}

export enum DepositType{
	SPEI = 1,
	CARD = 2,
}

export interface BankAccount{
	account_id?: number;
	name_account: string;
	rfc?: string;
	curp?: string;
	bank?: string;
	bank_participant?: number;
	is_primary?: boolean;
	clabe?: string;
	card_number?: string;
	postal_code?: string;
	email_account?: string;
}

export interface BankAccountForm{
	type: DepositType;
	owner_type: BankAccountOwnerType;
	account_owner: string;
	postal_code?: string;
	clabe?: string;
	card_number?: string;
	bank_participant?: number | null;
	rfc?: string;
	curp?: string;
}
